import { render, staticRenderFns } from "./CreateInvestisment.vue?vue&type=template&id=35474d2d&scoped=true"
import script from "./CreateInvestisment.vue?vue&type=script&lang=js"
export * from "./CreateInvestisment.vue?vue&type=script&lang=js"
import style0 from "./CreateInvestisment.vue?vue&type=style&index=0&id=35474d2d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35474d2d",
  null
  
)

export default component.exports